import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import theme from "../../../theme";
import mq from "../../../utils/mediaQuery";
import CaseItem from "../../CaseItem/v2";
import LayoutContentWrapper from "../../ContentWrapper";
import Heading from "../../Heading";

const Wrapper = styled.section`
  background: ${theme.color("primary")};
  position: relative;
  padding: 100px 0 ${theme.space("s")} 0;

  ${mq("2")} {
    padding-top: 175px;
    margin-bottom: 300px;
  }
`;

const StyledLayoutContentWrapper = styled(LayoutContentWrapper)`
  display: flex;
  position: relative;
  z-index: 0;
  flex-direction: column;
  ${mq("2")} {
    flex-direction: row;
  }
`;

const TitleWrapper = styled.div`
  color: white;
  ${mq("2")} {
    padding-bottom: ${theme.space("xxl")};
  }
`;

const TextWrapper = styled.div`
  ${mq("2")} {
    flex: 1 1 50%;
    padding: ${theme.space("s")};
    padding-left: 100px;
    > * {
      margin-top: 0;
    }
  }
`;

const LinksWrapper = styled.div`
  color: ${theme.color("text.light")};
  position: relative;

  ${mq("2")} {
    flex: 1 1 50%;
    padding: ${theme.space("s")};
    padding-left: 100px;

    > * {
      margin-top: ${theme.space("l")};
    }
  }
`;

const StyledContentWrapper = styled.div`
  margin-bottom: ${theme.space("xl")};
`;

const StyledCaseItem = styled(CaseItem)`
  position: absolute;
  width: calc(100% - 96px);
  background-color: white;
  display: none;

  ${mq("2")} {
    bottom: -275px;
    display: block;
  }
`;

function HeroV6({ title, introduction, content, caseItem, ...props }) {
  return (
    <Wrapper {...props}>
      <StyledLayoutContentWrapper columns={12}>
        <TextWrapper>
          <TitleWrapper>
            <Heading color={"text.light"} size={1}>
              {title}
            </Heading>
          </TitleWrapper>
          {introduction}
        </TextWrapper>
        <LinksWrapper>
          <StyledContentWrapper>{content}</StyledContentWrapper>
          {caseItem && <StyledCaseItem {...caseItem} />}
        </LinksWrapper>
      </StyledLayoutContentWrapper>
    </Wrapper>
  );
}

HeroV6.propTypes = {
  title: PropTypes.node.isRequired,
  introduction: PropTypes.node,
  content: PropTypes.node,
  caseItem: PropTypes.object,
};

HeroV6.defaultProps = {};

export default HeroV6;
